import { Action } from 'redux';
import { IDataSourceDetailInfo } from '../../../ts/models/IDataSourceInfo';
import { SetRemoteExtractRefreshProperties } from '../AppActionTypes';

export interface SetRemoteExtractRefreshPropertiesAction extends Action{
  datasource: IDataSourceDetailInfo;
}

export function setRemoteExtractRefreshProperties(
  datasource: IDataSourceDetailInfo,
): SetRemoteExtractRefreshPropertiesAction {
  return {
    type: SetRemoteExtractRefreshProperties,
    datasource,
  };
}
